import { Injectable } from '@angular/core';
import { ApiparserService } from '../apiparser/apiparser.service';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  constructor(private parser: ApiparserService) { }

  getAllTypeAndTemplate(params={}){
    return this.parser.hit('/rest/templates/types', 'get', {params:params}, false, true);
  }

  getTypedTemplalates(params={}){
    return this.parser.hit('/rest/templates/subtypesTemplates', 'get', {params:params}, false, true);
  }

  getTemplates(params={}){
    return this.parser.hit('/rest/templates/templates', 'get', {params:params}, false, true);
  }

  addNewTemplates(params={}){
      return this.parser.hit('/rest/templates/new', 'post', params);
  }

  updateTemplates(params={}){
      return this.parser.hit('/rest/templates', 'put', params);
  }
  deleteTemplate(params){
    return this.parser.hit('/rest/templates','delete',{params:params});
  }
}
